<template>
    <component :is="template" :channelId="channelId">
        <detail v-if="articleId" :article-id="articleId"></detail>
        <list v-else :channel-id="channelId"></list>
    </component>
</template>
<style lang="less" scoped>
    .article-header{
        margin: 0 auto 20px;
        text-align: center;
        & >h1{
            font-size: 20px;
            border-bottom: 1px solid lightgrey;
            padding: 10px;
        }
        & >h2{
            font-size: 16px;
            font-weight: normal;
            padding: 5px;
        }
    }
</style>
<script>
    import news from './News'
    import Detail from '../content/Detail'
    import List from '../content/List'

    import {mapGetters,mapActions} from 'vuex'
    export default {
        data() {
            return {
                template:'news'
            }
        },
        props:['channelId','articleId'],
        computed:{
            ...mapGetters('channel','')
        },
        components: {news,Detail,List},
        watch:{
            'channelId'(){
                this.$nextTick(()=>{
                    this.fetch_channel(this.channelId);
                })
            },
        },
        created() {
            if(this.channelId){
                this.fetch_channel(this.channelId);
            }
        },
        methods:{
            ...mapActions('channel',{'fetch_channel':'fetch'})
        }
    }
</script>
